import styled from 'styled-components';

export const SectionStyles = styled.section`
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  .title {
    margin-bottom: 16px;
  }

  .description {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .copy-icon {
    cursor: pointer;
  }
`;
